import PropTypes from 'prop-types'
import React, { useEffect, Fragment } from 'react'
import { routerPropTypes } from 'Types'
import { bindActionCreators } from 'redux'
import get from 'lodash/get'
import { connect } from 'react-redux'
import { GET_CONTENT } from 'Queries'
import { useQuery } from '@apollo/client'
import { sanitize } from 'Utils'
import NotFound from './component/NotFound'
import View from './component'
import { Loading } from './components'
import { trackLink, logCurrentPage } from 'Actions'
import {
  AmplitudeEvent,
  ErrorView,
  PageView,
  PageHelmet,
  TrackLinkDecrease,
  JourneyTracker,
  StoreLocation
} from 'Blocks'
import { PAGE_CONTEXT as p } from 'Constants'
import config from 'Config'

const pageName = p.HUB

const HubPageContainer = props => {
  const { logCurrentPage, location, match, screenType } = props
  
  function loadInstagram() {
    if (typeof window !== 'undefined') {
      setTimeout(() => {
        window.instgrm.Embeds.process()
      }, 1000)
    }
  }

  function amplitudeProps(content) {
    const amplitudeProps = {
      Sponsored: false,
      'Article UUID': content.uuid
    }
    if (content.sponsor) {
      amplitudeProps.Sponsored = true
      amplitudeProps.SponsoredBy = content.sponsor
    }
    return amplitudeProps
  }

  function gaCustomDimensions(content) {
    const { sponsor } = content
    return {
      sponsoredBy: sponsor
    }
  }

  function handleTrackLink() {
    props.trackLink({
      key: 'hub',
      value: props.match.params.uuid,
      depth: 2
    })
  }

  const variables = {
    arguments: {
      uuid: props.match.params.uuid,
      state: 'PUBLISHED'
    }
  }

  let additionalHeaders = null
  const queryString = get(location, 'search', '')
  if (queryString.match(/preview=1/)) {
    delete variables.arguments.state
    additionalHeaders = {
      headers: {
        nocache: true
      }
    }
  }

  useEffect(() => {
    handleTrackLink()
    loadInstagram()
    return () => {
      logCurrentPage({ uuid: '' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    loadInstagram()
    logCurrentPage({ uuid: match.params.uuid })
  }, [match, logCurrentPage])

  const { loading, error, data } = useQuery(GET_CONTENT, { variables })

  if (loading) {
    return <Loading />
  }

  if (error) return <ErrorView message={error.message} error={error} />

  return (
    <Fragment>
      <AmplitudeEvent
        eventType={config.amplitude.types.pageView.article}
        eventProps={amplitudeProps(data.content)}
      />
      <PageView
        dimensions={gaCustomDimensions(data.content)}
        url={location.pathname}
      />
      <PageHelmet
        pageName={pageName}
        titleFormat={{ HUB_TITLE: data.content.title.long }}
        description={sanitize(
          get(
            data,
            'content.title.long',
            config.helmet.defaultDescription
          )
        )}
      />
      <TrackLinkDecrease url={location.pathname} />
      <StoreLocation location={location} />
      <JourneyTracker
        routeName={pageName}
        name={pageName}
        location={location}
        params={match.params}
      />
      <View
        location={location}
        params={match.params}
        screenType={screenType}
        data={data}
      />
    </Fragment>
  )
}

HubPageContainer.propTypes = {
  ...routerPropTypes,
  logCurrentPage: PropTypes.func,
  screenType: PropTypes.any,
  trackLink: PropTypes.func
}

const mapStateToProps = state => ({
  screenType: get(state, 'UI.screenType', '')
})

const mapDispatchToProps = dispatch => ({
  trackLink: bindActionCreators(trackLink, dispatch),
  logCurrentPage: bindActionCreators(logCurrentPage, dispatch),
  dispatch
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HubPageContainer)
